import { useContext } from 'react';

import type { CmsRendering } from '@eneco/cms-adapter';

import { RenderingContext } from './rendering-context';

/**
 * The current rendering, whole — content, params and the names of its placeholder slots.
 *
 * `useContent`/`useParams`/`usePlaceholder` cover the common cases; this exists for the one case they
 * can't: a component that must know *which* slots the provider actually gave it. Slot names differ per
 * CMS (Sitecore's `jss-hero-left` vs a Sanity array field), so a component that hard-codes one name
 * silently renders nothing on the other provider. Reading the available names lets it adapt instead.
 *
 * Returns `undefined` outside a CMS-rendered component, rather than throwing like `useContent` — a
 * caller asking "what do I have?" can sensibly get "nothing".
 */
export const useRendering = (): CmsRendering | undefined => useContext(RenderingContext);
